export const BonusRoute = "/mein-remindme/praemien";
export const paidAnchor = "bezahlt";
export const openAnchor = "offen";
export const waitingAnchor = "warten";
